<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/text';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '@react-spectrum/text/package.json';

```jsx import
import {Heading, Keyboard, Text} from '@react-spectrum/text';
```

---
category: Content
---

# Keyboard

<p>{docs.exports.Keyboard.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Keyboard']} />

## Example

```tsx example
<Keyboard>⌘V</Keyboard>
```

## Content

The `Keyboard` component represents text that specifies a keyboard command,
which can be used within a Spectrum container such as a [Menu](Menu.html).
`Keyboard` provides no specific styling by itself, but receives styling
from the parent container. In addition, `Keyboard` will be automatically
placed within the container's layout according to Spectrum guidelines.

See [Menu](MenuTrigger.html#complex-menu-items) for examples of how to use the
`Keyboard` component in the context of a Spectrum container.
See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/kbd) for more
information about the semantics of the `kbd` element.

## Props

<PropTable component={docs.exports.Keyboard} links={docs.links} />
